import React, { useState, memo, useEffect, useRef } from "react";
import { Card, Col, List, Row, Skeleton, Slider, Space, Spin } from "antd";
import Meta from "antd/es/card/Meta";

import {
    DropDown,
    InputField,
    SearchInput,
    SubmitButton,
    TextComponent,
} from "../../../../components";
import styles from "./MyPlaylist.module.css";
import dummyImg from "../../../../assets/dummy.jpg";
import { AiFillStar, AiFillDelete, AiOutlineArrowRight } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PlaylistMiddleware } from "../../../../Store/Middlewares/PlaylistMiddleware";
import Modal from "../../../../components/modal/Modal";
import uploadTemplateImg from "../../../../assets/uploadTemplateImg.png";
import { showAlert } from "../../../../Store/Actions/GeneralActions";


const RenderItem = memo(({ item, loader }) => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (
        <List.Item
        // onClick={() => {
        //     navigate("/songIdeas/MusicList", {
        //         state: {
        //             headrTitle:  "",
        //             data: item,
        //         },
        //     });
        // }}
        >
            {loader ? (
                <Space
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        marginTop: "10px",
                    }}
                >
                    <Skeleton.Image active className={styles.image} />
                    <Skeleton.Input active size={20} />
                </Space>
            ) : (
                <Card
                    hoverable
                    style={{ width: "100%", textAlign: "center", alignItems: "center" }}
                    cover={
                        <img
                            className={styles.image}
                            src={item.image ? item.image : dummyImg}
                            alt="example"
                            resizeMode="cover"
                        />
                    }
                >
                    <Meta
                        style={{ textAlign: "center" }}
                        title={
                            <>
                                <TextComponent
                                    text={item?.name}
                                // textClass={styles.nameText}
                                />
                            </>
                        }
                        description={<TextComponent text={item.description} />}
                    />


                    {/* <Row onClick={() => { dispatch(PlaylistMiddleware.DeletePlaylist({ id: item.id })) }} className={styles.ratingCont}>
                        <AiFillDelete color="#00000" size={20} />
                    </Row> */}

                    <Col className={styles.addSongModal}>
                        <div onClick={() => { dispatch(PlaylistMiddleware.DeletePlaylist({ id: item.id })) }} className={styles.addSongModalDiv}>
                            <AiFillDelete color="#00000" size={30} />

                        </div>
                        <div onClick={() => { navigate("/songIdeas/MusicList", { state: { headrTitle: "", data: item, }, }); }} className={styles.addSongModalDiv}>
                            <AiOutlineArrowRight color="#00000" size={30} />
                        </div>

                    </Col>

                </Card>
            )}
        </List.Item>
    );
});

const MyPlaylist = () => {
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const user = useSelector(state => state.AuthReducer.user);
    const Playlist = useSelector(
        state => state.PlaylistReducer?.Playlist,
    );
    const [Error, setError] = useState(null);
    const [templateModal, settemplateModal] = useState(false);
    const [title, setTitle] = useState('');
    const [description, setdescription] = useState('');
    const [playlistImage, setplaylistImage] = useState(null)
    const imageRef = useRef();
    const [isSubmit, setisSubmit] = useState(false)

    const getData = (data = null) => {
        setLoader(true);
        dispatch(PlaylistMiddleware.getPlaylists({ name: '', id: user?.id }))
            .then(() => {
                setLoader(false);
            })
            .catch(() => {
                setLoader(false);
            });
    };
    useEffect(() => {
        getData()
    }, []);



    useEffect(() => {
        setTimeout(() => {
            setError(null);
        }, 3500);
    }, [Error]);


    const createPlaylist = () => {
        // setLoader(true);
        if (!title || !description || !playlistImage) {
            dispatch(
                showAlert({
                    type: "Error",
                    message: "All fields are required!",
                })
            );
            // setError('All fields are required!')
        } else {
            setisSubmit(true)
            dispatch(PlaylistMiddleware.createPlaylist({ name: title, description, image: playlistImage })).then(() => { setisSubmit(false); settemplateModal(false); setTitle(''); setdescription(''); setplaylistImage(''); setLoader(false); })
        }
    }


    return (
        <>
            <SubmitButton
                title="Create New Playlist"
                btnClass={styles.sectionBtnDark}
                onClick={() => {
                    settemplateModal(true);
                    setTitle('');
                    setdescription('');
                    setplaylistImage(null);
                }}
            />
            <List
                className={styles.listClass}
                grid={{
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 3,
                    xl: 4,
                    xxl: 4,
                }}
                dataSource={Playlist}
                renderItem={(item) => <RenderItem item={item} loader={loader} />}
            // footer={
            //     <div
            //         style={{
            //             width: "100%",
            //             display: "flex",
            //             justifyContent: "center",
            //             alignItems: "center",
            //         }}
            //     >
            //         {/* {findVendorsPaginationByCat?.links?.next != null ? (
            //             <div style={{ width: "50%" }}>
            //                 <SubmitButton title={"Load More"} onClick={onLoadMore} />
            //             </div>
            //         ) : null} */}
            //     </div>
            // }
            />


            <Modal
                isModalOpen={templateModal}
                setIsModalOpen={settemplateModal}
                closable={true}
                className={styles.modal}
            >
                <div className={styles.modalCon}>
                    <TextComponent
                        text={"Create Playlist"}
                        textClass={styles.modalHeading}
                    />
                    <Space
                        direction="vertical"
                        size="small"
                        style={{
                            display: "flex",
                            marginTop: "10px",
                        }}
                    >

                        <InputField
                            onChange={(e) => setTitle(e.target.value)}
                            value={title}
                            placeholder={"My Playlist"}
                            label={"Title"}
                        />
                        <InputField
                            onChange={(e) => setdescription(e.target.value)}
                            value={description}
                            placeholder={"My Description"}
                            label={"Description"}
                        />
                        <img
                            className={styles.uploadImage}
                            src={playlistImage ? URL.createObjectURL(playlistImage) : uploadTemplateImg}
                            alt="Add Template"
                            onClick={() => imageRef.current.click()}
                        />
                        <Row className={styles.btnClasss}>
                            {/* <SubmitButton title="Add Template" onClick={onSubmit} /> */}
                            <input
                                type="file"
                                accept="image/*"
                                ref={imageRef}
                                onChange={(e) => setplaylistImage(e.target.files[0])}
                                style={{ display: "none" }}
                            />
                        </Row>
                    </Space>
                    {isSubmit ? <Spin size="large" /> :
                        <SubmitButton
                            title={'Add Playlist'}
                            onClick={createPlaylist}
                            style={styles.add_temp_button}
                        />
                    }

                </div>
            </Modal>

        </>
    );
};

export default MyPlaylist;
